module.exports = __webpack_public_path__ + "img/finished-person.db2fa05b.png";